import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all planningGroups
export const getPlanningGroups = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/planning-group`);
    return response.data;
  } catch (error) {
    console.error("Error fetching planningGroups:", error.response?.data || error);
    throw error;
  }
};

// GET a single planningGroup
export const getPlanningGroupById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/planning-group/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching planningGroup:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new planningGroup
export const createPlanningGroup = async (planningGroupData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/planning-group`, planningGroupData);
    return response.data;
  } catch (error) {
    console.error("Error creating planningGroup:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing planningGroup
export const updatePlanningGroup = async (id, planningGroupData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/planning-group/${id}`, planningGroupData);
    return response.data;
  } catch (error) {
    console.error("Error updating planningGroup:", error.response?.data || error);
    throw error;
  }
};

// DELETE a planningGroup
export const deletePlanningGroup = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/planning-group/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting planningGroup:", error.response?.data || error);
    throw error;
  }
};
